import { jsx as o } from "react/jsx-runtime";
import { c as m } from "./tw-cn-mXgPecoF.mjs";
import { c as e } from "./index-BpNK5r1N.mjs";
const t = ["small", "medium", "large"], l = ["topLeftBottomRight", "topRightBottomLeft"], p = ({
  size: a,
  radius: r,
  device: i
}) => {
  if (r === "topLeftBottomRight")
    switch (a) {
      case "small":
        return i === "mobile" ? "rounded-tl-8 rounded-br-8" : "pc:rounded-tl-8 pc:rounded-br-8";
      case "medium":
        return i === "mobile" ? "rounded-tl-10 rounded-br-10" : "pc:rounded-tl-10 pc:rounded-br-10";
      case "large":
        return i === "mobile" ? "rounded-tl-16 rounded-br-16" : "pc:rounded-tl-16 pc:rounded-br-16";
    }
  switch (a) {
    case "small":
      return i === "mobile" ? "rounded-tr-8 rounded-bl-8" : "pc:rounded-tr-8 pc:rounded-bl-8";
    case "medium":
      return i === "mobile" ? "rounded-tr-10 rounded-bl-10" : "pc:rounded-tr-10 pc:rounded-bl-10";
    case "large":
      return i === "mobile" ? "rounded-tr-16 rounded-bl-16" : "pc:rounded-tr-16 pc:rounded-bl-16";
  }
}, w = e(["inline-flex items-center justify-center align-middle gap-2 py-2"], {
  variants: {
    type: {
      filled_primary: ["bg-fill-primary-main", "text-static-white"],
      filled_secondary: ["bg-fill-primary-weak", "text-text-primary-main"],
      filled_accent: ["bg-fill-accent-main", "text-static-white"],
      filled_accent_secondary: ["bg-fill-accent-weak", "text-text-accent-main"],
      filled_basic: ["bg-fill-neutral-weak1", "text-text-neutral-sub"],
      filled_white: ["bg-static-white", "text-text-neutral-main"],
      filled_blackop: ["bg-opacity-black-60", "text-static-white"],
      filled_whiteop: ["bg-opacity-white-80", "text-text-neutral-main"],
      outlined_primary: ["border border-line-primary-weak1 bg-static-white", "text-text-primary-main"],
      outlined_basic: ["border border-line-neutral-weak2 bg-static-white", "text-text-neutral-sub"],
      outlined_bubble: ["border border-line-primary-weak2", "text-text-primary-main", "bg-fill-primary-weak"]
    },
    size: {
      small: ["min-h-20 px-6 typography-label-10-bold"],
      medium: ["min-h-20 px-6 typography-caption-11-bold"],
      large: ["min-h-26 px-8 typography-body-12-bold"]
    },
    pcSize: {
      small: ["pc:min-h-20 pc:px-6 pc:typography-label-10-bold"],
      medium: ["pc:min-h-20 pc:px-6 pc:typography-caption-11-bold"],
      large: ["pc:min-h-26 pc:px-8 pc:typography-body-12-bold"]
    },
    radius: {
      normal: "rounded-6",
      capsule: "rounded-capsule",
      topLeftBottomRight: "",
      // compoundVariants 에서 처리
      topRightBottomLeft: ""
      // compoundVariants 에서 처리
    }
  },
  compoundVariants: [
    // Mobile
    ...t.flatMap(
      (a) => l.map((r) => ({
        size: a,
        radius: r,
        className: p({ size: a, radius: r, device: "mobile" })
      }))
    ),
    // PC
    ...t.flatMap(
      (a) => l.map((r) => ({
        pcSize: a,
        radius: r,
        className: p({ size: a, radius: r, device: "pc" })
      }))
    )
  ],
  defaultVariants: {
    type: "filled_primary",
    radius: "normal"
  }
}), c = "after:border-opacity-white-10 bg-opacity-black-80 text-text-membership-gold-weak2", n = "after:border-opacity-white-10 bg-opacity-black-80 text-text-membership-platinum-weak3", d = "after:border-opacity-white-10 bg-opacity-black-80 text-text-membership-dia-weak2", s = "after:border-line-neutral-weak2 bg-static-white text-text-neutral-main", b = "after:hidden !px-11", x = e(
  [
    "relative inline-flex items-center justify-center align-middle gap-2",
    "rounded-6",
    // 테두리는 after 가상요소로 안쪽에 그린다 — CSS border는 바깥 폭을 1px×2 키워 Figma(stroke inside) 총폭과
    // 어긋나므로, Thumbnail과 동일한 inset 테두리 패턴을 사용한다 (UCD-334)
    "after:pointer-events-none after:absolute after:inset-0 after:rounded-[inherit] after:border after:content-['']"
  ],
  {
    variants: {
      grade: {
        gold: c,
        platinum: n,
        dia: d,
        toping: s
      },
      shape: {
        badge: "",
        bubble: b,
        legacy_bubble: "after:hidden rounded-4"
      },
      size: {
        small: "min-h-[2.0rem] py-2 px-6 typography-label-10-bold",
        medium: "min-h-[2.0rem] py-2 px-6 typography-caption-11-bold",
        large: "min-h-[2.6rem] py-2 px-8 typography-body-12-bold"
      },
      pcSize: {
        small: "pc:min-h-[2.0rem] pc:py-2 pc:px-6 pc:typography-label-10-bold",
        medium: "pc:min-h-[2.0rem] pc:py-2 pc:px-6 pc:typography-caption-11-bold",
        large: "pc:min-h-[2.6rem] pc:py-2 pc:px-8 pc:typography-body-12-bold"
      }
    },
    defaultVariants: {
      grade: "gold",
      shape: "badge"
    }
  }
), f = e("object-contain", {
  variants: {
    size: {
      small: "size-10",
      medium: "size-10",
      large: "size-12"
    },
    pcSize: {
      small: "pc:size-10",
      medium: "pc:size-10",
      large: "pc:size-12"
    }
  }
}), k = e("object-contain", {
  variants: {
    size: {
      small: "w-24 h-10",
      medium: "w-24 h-10",
      large: "w-29 h-12"
    },
    pcSize: {
      small: "pc:w-24 pc:h-10",
      medium: "pc:w-24 pc:h-10",
      large: "pc:w-29 pc:h-12"
    }
  }
}), z = e("object-contain", {
  variants: {
    artwork: {
      medium: "size-12",
      large: "size-14"
    },
    size: {
      medium: "",
      large: ""
    },
    pcSize: {
      medium: "",
      large: ""
    }
  },
  compoundVariants: [
    { artwork: "medium", size: "medium", class: "inline-block" },
    { artwork: "medium", size: "large", class: "hidden" },
    { artwork: "large", size: "large", class: "inline-block" },
    { artwork: "large", size: "medium", class: "hidden" },
    { artwork: "medium", pcSize: "medium", class: "pc:inline-block" },
    { artwork: "medium", pcSize: "large", class: "pc:hidden" },
    { artwork: "large", pcSize: "large", class: "pc:inline-block" },
    { artwork: "large", pcSize: "medium", class: "pc:hidden" }
  ]
}), v = e("inline-flex items-center", {
  variants: {
    size: {
      medium: "w-19",
      large: "w-21"
    },
    pcSize: {
      medium: "pc:w-19",
      large: "pc:w-21"
    }
  }
}), S = e([], {
  variants: {
    artwork: {
      medium: "",
      large: ""
    },
    size: {
      medium: "",
      large: ""
    },
    pcSize: {
      medium: "",
      large: ""
    }
  },
  compoundVariants: [
    { artwork: "medium", size: "medium", class: "inline-block" },
    { artwork: "medium", size: "large", class: "hidden" },
    { artwork: "large", size: "large", class: "inline-block" },
    { artwork: "large", size: "medium", class: "hidden" },
    { artwork: "medium", pcSize: "medium", class: "pc:inline-block" },
    { artwork: "medium", pcSize: "large", class: "pc:hidden" },
    { artwork: "large", pcSize: "large", class: "pc:inline-block" },
    { artwork: "large", pcSize: "medium", class: "pc:hidden" }
  ]
}), C = e([
  "absolute left-1/2 -ml-4 -bottom-6 pc:bottom-auto pc:rotate-180 pc:top-[-5.5px] pc:clip-path-inset-[0.5px_0_0_0]"
]), B = e("object-contain", {
  variants: {
    artwork: {
      medium: "w-34 h-13",
      large: "w-40 h-14"
    },
    size: {
      medium: "",
      large: ""
    },
    pcSize: {
      medium: "",
      large: ""
    }
  },
  compoundVariants: [
    { artwork: "medium", size: "medium", class: "inline-block" },
    { artwork: "medium", size: "large", class: "hidden" },
    { artwork: "large", size: "large", class: "inline-block" },
    { artwork: "large", size: "medium", class: "hidden" },
    { artwork: "medium", pcSize: "medium", class: "pc:inline-block" },
    { artwork: "medium", pcSize: "large", class: "pc:hidden" },
    { artwork: "large", pcSize: "large", class: "pc:inline-block" },
    { artwork: "large", pcSize: "medium", class: "pc:hidden" }
  ]
}), _ = e(
  [
    "box-border inline-flex items-center justify-center",
    "px-4 rounded-capsule",
    "bg-fill-primary-main text-static-white"
  ],
  {
    variants: {
      size: {
        medium: ["min-w-[1.6rem] min-h-[1.6rem] py-1 typography-label-10-bold"],
        large: ["min-w-[2rem] min-h-[2rem] py-2 typography-body-12-bold"]
      },
      pcSize: {
        medium: ["pc:min-w-[1.6rem] pc:min-h-[1.6rem]  pc:py-1 pc:typography-label-10-bold"],
        large: ["pc:min-w-[2rem] pc:min-h-[2rem]  pc:py-2 pc:typography-body-12-bold"]
      }
    }
  }
), j = e(
  ["inline-flex items-center justify-center py-2", "bg-fill-neutral-weak text-text-neutral-sub"],
  {
    variants: {
      size: {
        medium: ["typography-caption-11-regular px-4 min-h-18 rounded-4 gap-1"],
        large: ["typography-body-12-regular px-8 min-h-26 rounded-6 gap-2"]
      },
      pcSize: {
        medium: ["pc:typography-caption-11-regular pc:px-4 pc:min-h-18 pc:rounded-4 pc:gap-1"],
        large: ["pc:typography-body-12-regular pc:px-8 pc:min-h-26 pc:rounded-6 pc:gap-2"]
      }
    }
  }
), V = e([], {
  variants: {
    size: {
      medium: ["size-12"],
      large: ["size-14"]
    },
    pcSize: {
      medium: ["pc:size-12"],
      large: ["pc:size-14"]
    }
  }
}), L = e([], {
  variants: {
    size: {
      medium: ["w-[0.5rem] h-[1.1rem]"],
      large: ["w-[0.6rem] h-[1.3rem]"]
    },
    pcSize: {
      medium: ["pc:w-[0.5rem] pc:h-[1.1rem]"],
      large: ["pc:w-[0.6rem] pc:h-[1.3rem]"]
    }
  }
}), R = e(["inline-flex items-center justify-center rounded-capsule border"], {
  variants: {
    type: {
      primary: ["border-line-primary-weak2 text-text-primary-main bg-fill-primary-weak"],
      secondary: ["border-line-neutral-weak3 text-text-neutral-sub bg-fill-neutral-weak"]
    },
    size: {
      medium: ["min-h-[1.6rem] px-6 typography-label-8-bold pt-1"],
      large: ["min-h-[2.2rem] px-8 typography-body-12-bold"]
    },
    pcSize: {
      medium: ["pc:min-h-[1.6rem] pc:px-6 pc:typography-label-8-bold"],
      large: ["pc:min-h-[2.2rem] pc:px-8 pc:typography-body-12-bold"]
    }
  },
  defaultVariants: {
    type: "primary"
  }
}), T = e(["absolute left-1/2 pointer-events-none"], {
  variants: {
    type: {
      primary: "[--bubble-fill:theme(colors.fill-primary-weak)] [--bubble-stroke:theme(colors.line-primary-weak2)]",
      secondary: "[--bubble-fill:theme(colors.fill-neutral-weak)] [--bubble-stroke:theme(colors.line-neutral-weak3)]"
    },
    size: {
      medium: "-bottom-3 -ml-4 h-4 w-8",
      large: "bottom-[-4.1px] -ml-5 h-5 w-10"
    },
    pcSize: {
      medium: "pc:-bottom-3 pc:-ml-4 pc:h-4 pc:w-8",
      large: "pc:bottom-[-4.1px] pc:-ml-5 pc:h-5 pc:w-10"
    }
  },
  defaultVariants: {
    type: "primary"
  }
}), u = e([
  "absolute -top-2 -right-1 size-5 translate-x-full rounded-capsule bg-fill-primary-main"
]), N = ({ className: a, style: r }) => {
  const i = u();
  return /* @__PURE__ */ o("div", { className: m(i, a), style: r });
};
export {
  N as D,
  C as a,
  B as b,
  f as c,
  k as d,
  z as e,
  v as f,
  S as g,
  _ as h,
  j as i,
  L as j,
  V as k,
  T as l,
  x as m,
  R as n,
  w as p
};
